<template>
  <div>
    <modal id="cookie-modal" v-model="showCookiesModal" effect="fade">
      <div slot="modal-header" class="modal-header">Cookie Information</div>
      <div class="modal-data">
        <p>
          The Privacy and Electronic Communications (EC Directive) Regulations 2003 (the Regulations) cover the use of
          cookies and similar technologies for storing information, and accessing information stored, on a user’s
          equipment such as their computer or mobile.
        </p>
        <p>
          A cookie is a small file, typically of letters and numbers, downloaded on to a device when the user accesses
          certain websites. Cookies are then sent back to originating website on each subsequent visit. Cookies are
          useful because they allow a website to recognize a user’s device. The Regulations apply to cookies and also to
          similar technologies for storing information. For more information see:
          <a href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a>
        </p>
        <p>
          Web “Cookies” are also used within myCFMportal. Session cookies are used to establish the ability to access
          myCFMportal after logging into the website and are used to identify and maintain the user session within
          myCFMportal. A third cookie is used to ensure a secure third-party can collect the user data as indicated
          above.
        </p>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" @click="showCookiesModal = false;">Close</button>
      </div>
    </modal>

    <div class="flex flex-vcenter-hcenter cfm-footer">
      <ul class="list-inline footer-links">
        <li><a href="/custom-login/cfm-privacy-policy.html" target="_blank">Privacy Policy</a></li>
        <li><a href="/custom-login/cfm-terms-conditions.html" target="_blank">Terms and Conditions</a></li>
        <li><a href="#" @click="showEvidonCookies">Cookies</a></li>
        <li class="copyright">
          ©2019-{{ new Date().getFullYear() }} CFM International is a joint company of Safran Aircraft Engines, France and General Electric Company,
          U.S.A.
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import modal from "build-ui-x/src/Modal";

export default {
  components: {
    modal
  },
  data() {
    return {
      showCookiesModal: false,
      footerLinks: [
        {
          label: "Privacy Policy",
          url: "/custom-login/ghae-privacy-policy.html"
        },

        {
          label: "Terms and Conditions ",
          url: "/custom-login/ghae-terms-conditions.html"
        }
      ]
    };
  },
  methods: {
    showEvidonCookies(e) {
      e.preventDefault();
      window.evidon.notice.showOptions();
    }
  }
};
</script>
<style lang="less" scoped>
.cfm-footer {
  font-size: 12px;
  position: absolute;
  width: 100%;
  height: 30px;
  border-top: solid 1px #ccc;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: #fff;
  bottom: -5px;
}
.footer-links {
  margin-bottom: 0;
  a {
    color: #0077cc;
  }
}
.modal-header {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 18px;
  background-color: #edeeef;
}
.modal-data {
  overflow-y: auto;
  max-height: 400px;
  line-height: 2;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 11px;
  font-weight: normal;
  color: #000000;
  text-align: justify;
}
.modal-data dl dt {
  line-height: 2 !important;
}
.modal-data dl dd {
  line-height: 2 !important;
}
.modal-footer {
  border-top-color: #e1e2e5;
}
</style>
